<template>
    <div v-if="field && field.$error">
        <div class="error" v-if="!field.required && field.$params.required">{{ label }}
            {{$t("TotemFormErrors.required_field")}}
        </div>
        <div class="error" v-if="!field.email && field.$params.email">{{ label }}
            {{$t("TotemFormErrors.is_not_email")}}
        </div>
        <div class="error" v-if="!field.validName && isNameField">{{ label }}
            {{$t("TotemFormErrors.no_numerics_accepted")}}
        </div>
        <div class="error" v-if="!field.minLength && field.$params.minLength">{{ label }}
            {{$t("TotemFormErrors.must_contain")}} {{ field.$params.minLength.min }}
            {{$t("TotemFormErrors.characters")}}
        </div>
        <div class="error" v-if="!field.repeatPassword && field.$params.repeatPassword">
            {{$t("TotemFormErrors.passwords_identical")}}
        </div>
        <div class="error" v-if="!field.passwordRequirements && field.$params.passwordRequirements">
            {{$t("TotemFormErrors.password_rules")}}
        </div>
        <div class="error" v-if="!field.checkboxRequired && field.$params.checkboxRequired">
            {{ label }} {{$t("TotemFormErrors.required_field")}}
        </div>
    </div>
</template>

<script>
    export default {
        name: 'totem-form-finnish-label-error',
        props: {
            field: {
                Object
            },
            label: {
                type: String
            }
        },
        computed: {
            isNameField () {
                return this.field && Object.hasOwn(this.field, 'validName')
            }
        }
    }
</script>

<style lang="scss" scoped>
    .error {
        font-size: 1.4rem;
        color: $thunderbird;
        padding-top: 7px;
    }
</style>
